import { useRequest } from 'ahooks';
import moment from 'moment';

import {
  Title,
  Form,
  MaskedInput,
  ScreenWarning,
  Footer,
  ButtonWithArrowRight,
} from '~components';
import { useTransshipment } from '~contexts/TranshipmentContext';
import { Spouse } from '~services';

import { formatNumberCpf } from './formaters';
import validationSchema from './validation';
import { Values } from './types';
import * as Styled from './styled';

function SpousePersonalDataCompletionForm() {
  const transshipment = useTransshipment();

  const initialValues = {
    cpf: '',
    birthdayDate: '',
    politicallyExposedPerson: false,
  };

  const { runAsync: updateSpouse, loading: isLoading } = useRequest(
    Spouse.updateSpouseData,
    {
      manual: true,
    }
  );

  const handleSubmit = async (values: Values) => {
    const valuesFinal = {
      cpf: formatNumberCpf(values.cpf),
      birthday_date: moment(values.birthdayDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      ),
      politically_exposed_person: values.politicallyExposedPerson,
    };

    await updateSpouse(transshipment?.id, valuesFinal);

    transshipment.nextStep();
  };

  if (transshipment.type !== 'spouse') return;

  return (
    <Form<Values>
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
      aria-labelledby="form-document"
    >
      <Styled.Container>
        <Styled.Content>
          <Title>Olá, {transshipment.data.name}</Title>
          <Styled.Description>
            O representante legal,{' '}
            <strong>{transshipment.data.representative}</strong> da empresa{' '}
            <strong>{transshipment.data.enterprise}</strong>, está abrindo uma
            solicitação junto a FreteBras. Com isso, iremos precisar de alguns
            dados seus enquanto cônjuge.
          </Styled.Description>
          <Styled.FieldRow>
            <MaskedInput
              mask="999.999.999-99"
              name="cpf"
              label="CPF *"
              type="tel"
              width="100%"
              placeholder="Seu CPF"
            />
            <MaskedInput
              mask="99/99/9999"
              name="birthdayDate"
              label="Data de nascimento *"
              type="tel"
              width="100%"
              placeholder="00/00/0000"
            />
          </Styled.FieldRow>
          <Styled.FieldRow>
            <Styled.Checkbox
              name="politicallyExposedPerson"
              label={
                <Styled.CheckboxLabel>
                  Pessoa Exposta Politicamente (PEP)?
                </Styled.CheckboxLabel>
              }
            />
          </Styled.FieldRow>

          <ScreenWarning
            message={`Atenção! Se você não está ciente dessa solicitação, entre em contato com o ${transshipment.data.representative}. Caso não conheça a pessoa, desconsidere esta solicitação.`}
          />
        </Styled.Content>
        <Footer
          marginTop="auto"
          rightButton={
            <ButtonWithArrowRight
              width="100%"
              variant="primary"
              type="submit"
              loading={isLoading}
            >
              Continuar
            </ButtonWithArrowRight>
          }
        />
      </Styled.Container>
    </Form>
  );
}

export default SpousePersonalDataCompletionForm;
